// extracted by mini-css-extract-plugin
export default {"elementCreator":"ElementCreator_elementCreator__Zt96r","deleteButton":"ElementCreator_deleteButton__rb2hm","typeSelector":"ElementCreator_typeSelector__3Jr8v"};